var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-2 py-6",class:{ used: _vm.isActive == 0, req: _vm.idx == 5 },attrs:{"outlined":"","tile":""},on:{"click":function($event){return _vm.useLetter()}}},[_c('h2',[_vm._v(_vm._s(_vm.letter))])])}
var staticRenderFns = []

export { render, staticRenderFns }